import { useRef } from 'react';
import { useIsStickyElementPinned } from 'app/lib/hooks';
import { ModalActions } from 'app/components/core/Modal';
import * as styles from './DialogWithChapters.css';

export function DialogActions({ children }) {
    const ref = useRef();
    const isPinned = useIsStickyElementPinned(ref);

    return (
        <ModalActions ref={ref} className={styles.actions} data-pinned={isPinned}>
            {children}
        </ModalActions>
    );
}
